import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types'
import ProfileHeader from '../../components/Profiles/ProfileHeader'
import ProfileBreadcrumbs from '../../components/Profiles/ProfileBreadcrumbs'
import ProfileLeftSidebar from '../../components/Profiles/ProfileLeftSidebar'
import ProfileMainContent from '../../components/Profiles/ProfileMainContent'
import ProfileRightSidebar from '../../components/Profiles/ProfileRightSidebar'
import styles from './ProfileTemplate.module.scss'

/**
 * general profile template:
 * - Full-width: profile header (outside container)
 * - Container: row 1 = breadcrumbs (full width); row 2 = left (3 col), main (6 col), right (3 col)
 * Breakpoints: XL ≥1200px, L ≥992px, M ≥768px, XS <576px
 */
export default function ProfileTemplate({
  profileType,
  headerProps,
  breadcrumbItems,
  breadcrumbRightContent,
  leftSidebarContent,
  mainContent,
  rightSidebarContent,
}) {
  const variant = profileType === 'business' ? 'business' : 'user'

  return (
    <div className={styles.wrapper}>
      <ProfileHeader variant={variant} {...headerProps} />

      <Container fluid="md" className={styles.container}>
        <Row className={styles.breadcrumbRow}>
          <Col xs={12}>
            <ProfileBreadcrumbs items={breadcrumbItems} rightContent={breadcrumbRightContent} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={3} className={styles.colLeft}>
            <ProfileLeftSidebar>{leftSidebarContent}</ProfileLeftSidebar>
          </Col>
          <Col xs={12} lg={6} className={styles.colMain}>
            <ProfileMainContent>{mainContent}</ProfileMainContent>
          </Col>
          <Col xs={12} lg={3} className={styles.colRight}>
            <ProfileRightSidebar>{rightSidebarContent}</ProfileRightSidebar>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

ProfileTemplate.propTypes = {
  profileType: PropTypes.oneOf(['user', 'business']).isRequired,
  headerProps: PropTypes.object,
  breadcrumbItems: PropTypes.array,
  breadcrumbRightContent: PropTypes.node,
  leftSidebarContent: PropTypes.node,
  mainContent: PropTypes.node,
  rightSidebarContent: PropTypes.node,
}

ProfileTemplate.defaultProps = {
  headerProps: {},
  breadcrumbItems: [],
  leftSidebarContent: null,
  mainContent: null,
  rightSidebarContent: null,
}
